import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import { MatInputModule } from '@angular/material/input'
import {
  MatDatepicker,
  MatDatepickerModule,
} from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { NgxMaskDirective } from 'ngx-mask'
import {
  ErrorRequestModel,
} from '../../../../core/models/response.model'
import { emailValidator } from '../../../../shared/utils/email_validator'
import { ResponsibleService } from '../../../../core/services/person/responsible/responsible.service'

@Component({
  selector: 'responsible-client-edit-form',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMaskDirective,
  ],
  templateUrl: './responsible-client-edit-form.component.html',
  styleUrl: './responsible-client-edit-form.component.scss',
  providers: [ResponsibleService],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResponsibleClientEditFormComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private responsibleService: ResponsibleService,
    private snackbar: SnackbarCustomService,
  ) {
    const today = new Date() // Data atual
    const currentYear = today.getFullYear()
    const currentMonth = today.getMonth()
    const currentDay = today.getDate()
    this.maxDate = new Date(currentYear - 18, currentMonth, currentDay)
  }

  form: FormGroup = new FormGroup({})
  loading = false

  @Output() response = new EventEmitter()
  @Input() editItem: any = {}
  @Input() idPerson = 0
  @ViewChild('birth') datepicker: MatDatepicker<any> | undefined

  listType: any[] = []

  maxDate!: Date

  ngOnInit(): void {
    this.createForm()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }

  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm()
    }
  }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.edit) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  fillForm() {
    this.form.get('name')?.setValue(this.editItem.data.nome)
    this.form.get('email')?.setValue(this.editItem.data.email)
    this.form.get('phone')?.setValue(this.editItem.data.telefone)
  }

  resetForm() {
    this.form.reset()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      phone: ['', [Validators.required, Validators.minLength(10)]],
      email: ['', [Validators.required, emailValidator()]],
    })
  }

  createConsultant() {
    this.loading = true
    const model = this.createModel()
    this.responsibleService.createResponsible(model).subscribe({
      next: (response: any) => {
        if (response.statusCode == 200) {
          this.snackbar.success(response.message)
          this.response.emit({ refresh: true, clear: true })
          this.resetForm()
          this.loading = false
          // this.addConsultant(response.data.id, response.message)
        } else {
          this.snackbar.info(response.message)
          this.loading = false
        }
        // this.snackbar.success(response.message)
        // this.response.emit({ refresh: true, clear: true })
        // this.resetForm()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  // addConsultant(idConsultant: number, message: string) {
  //   const model = {
  //     consultorId: idConsultant,
  //     clienteId: this.idClient,
  //   }
  //   this.responsibleService.addResponsiblePerson(model).subscribe({
  //     next: (response: any) => {
  //       this.snackbar.success(message)
  //       this.response.emit({ refresh: true, clear: true })
  //       this.resetForm()
  //       this.loading = false
  //     },
  //     error: (err: ErrorRequestModel) => {
  //       this.loading = false
  //       this.snackbar.errorRequest(err)
  //     },
  //     complete: () => {
  //       this.loading = false
  //     },
  //   })
  // }

  editConsultant() {
    this.loading = true
    const model = this.createModel(true)
    this.responsibleService.editResponsible(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.response.emit({ refresh: true, clear: true })
        this.resetForm()
        this.loading = false
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  cancel() {
    this.response.emit({ refresh: false, clear: true })
    this.resetForm()
  }

  createModel(edit = false) {
    if (edit) {
      return {
        id: this.editItem.data.id,
        // clienteId: this.idClient,
        pessoaId: this.idPerson,
        nome: this.form.controls['name'].value,
        email: this.form.controls['email'].value,
        telefone: this.form.controls['phone'].value,
      }
    } else {
      return {
        // clienteId: this.idClient,
        pessoaId: this.idPerson,
        nome: this.form.controls['name'].value,
        email: this.form.controls['email'].value,
        telefone: this.form.controls['phone'].value,
      }
    }
  }

  openDatepicker() {
    if (this.datepicker) {
      this.datepicker.open()
    }
  }
}
